import { useState } from 'react';
import cn from 'classnames';
import InfiniteScroll from '@dealroadshow/uikit-infinite-scroll';
import { useAskAiChatListContext } from '@/creditflowresearch/application/AskAiChat/context/AskAiChatContext';
import ChatHistoryList from './ChatHistoryList';
import styles from './chatHistoryList.module.scss';

interface IInfiniteChatHistoryListProps {
  className?: string,
  dataTest: string,
}

const InfiniteChatHistoryList = ({ className, dataTest }: IInfiniteChatHistoryListProps) => {
  const { isChatListFetching, hasMoreChats, loadMoreChats } = useAskAiChatListContext();
  const [scrollContainer, setScrollContainer] = useState<HTMLDivElement | null>(null);
  const [list, setList] = useState<HTMLDivElement | null>(null);

  return (
    <div ref={ setScrollContainer } className={ cn(styles.scroller, className) }>
      <InfiniteScroll
        fetchCallback={ loadMoreChats }
        isFetching={ isChatListFetching }
        scrollContainerRef={ scrollContainer }
        isAllItemsFetched={ !hasMoreChats }
        resizeObserverElement={ list ?? undefined }
      >
        <ChatHistoryList ref={ setList } dataTest={ dataTest } hasLoadMoreButton={ false } />
      </InfiniteScroll>
    </div>
  );
};

export default InfiniteChatHistoryList;
